module.exports = __webpack_public_path__ + "img/email.2299c598.svg";